import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Standard Add Payment Modal (JSM/JPD in trial, not invoiceable, can add payment).
 */
export function isEligibleForStandardAddPaymentModal(
	context: EditionAwarenessContextType,
): boolean {
	const { product, edition, isInTrial, invoiceableStatus, canAddPaymentDetails } = context;

	return Boolean(
		isEditionOneOf(edition, ['standard']) &&
		isInTrial &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails &&
		isProductOneOf(product, ['jira-service-management', 'jira-product-discovery']),
	);
}
